<div class="container">
  <section class="legacy-setup" data-testid="legacy-setup">
    <button
      type="button"
      class="legacy-toggle"
      (click)="legacyOpen = !legacyOpen"
      [attr.aria-expanded]="legacyOpen"
      data-testid="legacy-setup-toggle"
    >
      <span class="legacy-title">Legacy setup</span>
      <span class="legacy-hint">Labor and equipment code setup from older projects</span>
      <mat-icon class="legacy-chevron" [class.open]="legacyOpen">expand_more</mat-icon>
    </button>

    @if (legacyOpen) {
      <mat-tab-group [selectedIndex]="0">
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon title="Labor Setup" svgIcon="sn-labor"></mat-icon>
            <span>&nbsp;Labor setup</span>
          </ng-template>
          <ng-template matTabContent>
            <app-project-labor-setup [project]="project"></app-project-labor-setup>
          </ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <span>&nbsp;Equipment setup</span>
          </ng-template>
          <ng-template matTabContent>
            <app-project-equipment-setup [project]="project"></app-project-equipment-setup>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    }
  </section>
</div>
